<button
  (click)="chipClicked(chipValue); toggleActive();"
  *ngIf="variant === 'checkbox'"
  [disabled]=disabled
  [ngClass]="getClass()"
  class="chip-element"
>
  <ng-container *ngTemplateOutlet="chipIcons">
  </ng-container>
  <span [ngClass]="chipDescription ? 'chip-label-desc' : 'chip-label'">
    {{chipLabel}}
    <span *ngIf="chipDescription">:</span>
  </span>
  <span class="chip-desc">
    {{ chipDescription }}
  </span>
</button>

<ng-container *ngIf="variant === 'dropdown'">
  <button
    [ngClass]="getClass()"
    [nzClickHide]="false"
    [nzDisabled]=disabled
    [nzDropdownMenu]="menu"
    class="chip-element"
    nz-dropdown
    nzTrigger="click"
  >
    <ng-container *ngTemplateOutlet="chipIcons">
    </ng-container>
    <span [ngClass]="chipDescription ? 'chip-label-desc' : 'chip-label'">
    {{chipLabel}}
      <span *ngIf="chipDescription">:</span>
  </span>
    <span class="chip-desc">
    {{ chipDescription }}
  </span>
    <span class="chip-caret-down">
    <span nz-icon nzTheme="outline" nzType="caret-down"></span>
  </span>
  </button>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <nz-checkbox-wrapper (nzOnChange)="chipDropdownChanged($event)" class="dropdown-section" nz-menu>
      <div *ngFor="let chipDropDownSection of chipDropdownItems; let i = index" class="dropdown-section-wrapper">
        <div class="dropdown-section-title" nz-row>
          <span nz-col nzSpan="24">{{chipDropDownSection.title}}</span>
        </div>
        <div nz-row nzGutter="14">
          <div
            *ngFor="let chipDropDownItem of chipDropDownSection.items"
            class="dropdown-item-checkbox"
            nz-col
            nz-menu-item
            nzSpan="8"
          >
            <label [nzValue]="chipDropDownItem.value" nz-checkbox>
              {{chipDropDownItem.label}}
              <span *ngIf="chipDropDownItem.quantity" class="dropdown-quantity">({{chipDropDownItem.quantity}})</span>
            </label>
          </div>
        </div>
      </div>
    </nz-checkbox-wrapper>
  </nz-dropdown-menu>

  <ng-content select="chip-dropdown">
  </ng-content>
</ng-container>

<ng-template #chipIcons>
  <span class="chip-icon">
    <span *ngIf="!activeChip" [style.color]="iconColor">
      <ng-content select="[chip-icon]">
      </ng-content>
    </span>
     <span *ngIf="activeChip" [style.color]="iconColorSelected">
      <ng-content select="[chip-icon-selected]">
      </ng-content>
     </span>
  </span>
</ng-template>
